import { Article, Product } from '../../@types/wishlist.js';

export class FilterAction {
  readonly filterStrategy: (product: Product) => boolean;

  constructor(filterStrategy: (product: Product) => boolean) {
    this.filterStrategy = filterStrategy;
  }

  public static createArticleBasedFilter(apply: (article: Article, product?: Product) => boolean) {
    return new FilterAction((product) => FilterAction.applyOnArticle(product, apply));
  }

  private static applyOnArticle(product: Product, apply: (article: Article, product?: Product) => boolean) {
    if (product.articleId) {
      return product.articles.some((article) => article.id === product.articleId && apply(article));
    }
    return product.articles.some((article) => apply(article, product));
  }
}
